import { autoinject, bindable } from 'aurelia-framework';
import './dynamic-table.scss';

@autoinject
export class DynamicTable {
  @bindable headers: any[] = [];
}
